import { render } from "./IndexByWsxy.vue?vue&type=template&id=6aba5ac4&scoped=true"
import script from "./IndexByWsxy.vue?vue&type=script&lang=js"
export * from "./IndexByWsxy.vue?vue&type=script&lang=js"

import "./IndexByWsxy.vue?vue&type=style&index=0&id=6aba5ac4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6aba5ac4"

export default script